import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NRIconComponent } from '@shared/components/nr-icon/nr-icon.component';
import futureReleases from 'src/app/components/home-page/future-releases.json';

@Component({
  selector: 'future-releases',
  imports: [CommonModule, NRIconComponent],
  templateUrl: './future-releases.component.html',
})
export class FutureReleasesComponent implements OnInit {
  features = [];

  ngOnInit() {
    this.features = futureReleases;
  }
}
